import styled from "styled-components";
import { ListItem } from "@material-ui/core";
import { lightBlack } from "../Style/Style";

export const MenuItem = styled(ListItem)<({ color?: string })>`
  cursor: pointer;
  color: ${props => props.color ? props.color : lightBlack};
`;